export default function () {
        return process.env.VUE_APP_APP_NAME;
}


